/**
 * * end of cart upsell block part
 */
document.addEventListener("DOMContentLoaded", function () {
  const amountFreeProduct = document.querySelector("[data-treshold-product]")
    ? document.querySelector("[data-treshold-product]").getAttribute("data-treshold-product")
    : null;

  var cartTotalEl = document.querySelector(".gb-totals-total-value");
  var cart_total = cartTotalEl ? (cartTotalEl.textContent || "").trim() : "";
  if (amountFreeProduct > 0 && show_progress_bar) {
    const hasPremiumKit = document.querySelector(".premium-attachment-kit") !== null;
    if (hasPremiumKit) {
      console.log("Premium kit detected - skipping auto free gift trigger");
      return;
    }
    setTimeout(function () {
      var el = document.querySelector(".gb-totals-total-value");
      var cart_total = el ? (el.textContent || "").trim() : "";
      if (cart_total >= amountFreeProduct) {
        if (document.querySelector(".cart-item.gb-find-remove-product")) {
          console.log("Free product already in cart");
        } else {
          console.log("Adding free product");
          var trigger = document.querySelector(".gb-free-product-trigger");
          if (trigger) trigger.click();
        }
      } else {
        console.log("Removing free product - under threshold");
        var removeBtn = document.querySelector(".gb-remove-product");
        if (removeBtn) removeBtn.click();
      }
    }, 3000);

    document.body.addEventListener("click", function (e) {
      if (!e.target.closest(".gb-sumbit-free")) return;
      setTimeout(function () {
        var el = document.querySelector(".gb-totals-total-value");
        var cart_total = el ? (el.textContent || "").trim() : "";
        if (cart_total >= amountFreeProduct) {
          if (!document.querySelector(".cart-item.gb-find-remove-product")) {
            var trigger = document.querySelector(".gb-free-product-trigger");
            if (trigger) trigger.click();
          }
        } else {
          var removeBtn = document.querySelector(".gb-remove-product");
          if (removeBtn) removeBtn.click();
        }
      }, 3000);
    });
  }

  document.body.addEventListener("change", function (e) {
    var select = e.target.closest && e.target.closest(".gb-change-variant_id");
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    var id_change = opt ? opt.getAttribute("data-variant-id") : null;
    if (!id_change) {
      console.error("No data-variant-id found on selected option");
      return;
    }
    var block = select.closest(".gb-get-main-freq-pro");
    var input = block ? block.querySelector(".product-variant-id") : null;
    if (input) input.value = id_change;
  });
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".cart-drawer .gbfrequently-bought-with-main-whole .select__select")) {
    const parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) {
      console.log("Error: Could not find parent block");
      return;
    }

    const allValues = Array.from(parentBlock.querySelectorAll(".select__select"))
      .map((sel) => sel.value)
      .join(" / ");

    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      console.log("Error: Could not find variant selector");
      return;
    }

    const matchedOption = Array.from(variantSelect.options).find((option) => option.text.includes(allValues));

    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      console.log("Error: Could not find id input field");
      return;
    }

    if (matchedOption) {
      console.log("Matched variant option value:", matchedOption.value);
      idInput.value = matchedOption.value;
      console.log("Set ID input value to:", idInput.value);
    } else {
      console.log("No matching variant found for:", allValues);
    }
  }
});

// Add validation for form submissions: require id when in single-variant mode; skip when form has items[] (bundles / premium kit)
document.addEventListener("submit", function (e) {
  if (typeof Elixir_ProductFormExists !== 'function' || !Elixir_ProductFormExists()) return;
  if (typeof Elixir_GetProductForm !== 'function' || Elixir_GetProductForm() !== e.target) return;
  if (typeof Elixir_GetProductFormVariantId !== 'function') return;
  if (typeof Elixir_ProductFormHasItemsInputs === 'function' && Elixir_ProductFormHasItemsInputs()) return;
  const variantId = Elixir_GetProductFormVariantId();
  if (!variantId) {
    console.log("Preventing submission - missing id parameter (single-product form has no variant id)");
    e.preventDefault();
    if (window.ThemeEditorToast && typeof window.ThemeEditorToast.show === 'function') {
      window.ThemeEditorToast.show('Add to cart failed: missing variant ID on product form.', { type: 'error', duration: 5000 });
    }
    return false;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  function handleCartQuantityChange(e) {
    var cartItem = e.target.closest(".cart-item");
    if (!cartItem) return;
    var trigger =
      e.target.closest(".quantity__button") ||
      e.target.closest(".quantity__input") ||
      (e.target.matches && e.target.matches(".quantity__input") ? e.target : null);
    if (!trigger) return;
    var quantityInputWrap = trigger.closest(".quantity-input");
    var qtyInput = quantityInputWrap ? quantityInputWrap.querySelector(".quantity__input") : null;
    var variantId = qtyInput ? qtyInput.getAttribute("data-quantity-variant-id") : null;
    var form = trigger.closest("form");
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput && variantId) {
      console.log("Adding missing ID input to cart form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = variantId;
      form.appendChild(newIdInput);
    } else if (idInput && variantId) {
      idInput.value = variantId;
    }
  }
  document.addEventListener("click", handleCartQuantityChange);
  document.addEventListener("change", handleCartQuantityChange);
  document.addEventListener("input", handleCartQuantityChange);

  var checkoutBtn = document.getElementById("CartDrawer-Checkout");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function (e) {
      var form = document.getElementById("CartDrawer-Form");
      if (!form) return;
      var cartItems = form.querySelectorAll(".cart-item");
      if (cartItems.length === 0) {
        console.log("No items in cart, preventing checkout");
        e.preventDefault();
        return false;
      }
      console.log("Cart checkout with", cartItems.length, "items");
    });
  }

  document.addEventListener("keydown", function (e) {
    var input =
      (e.target.matches && e.target.matches(".quantity__input")
        ? e.target
        : e.target.closest && e.target.closest(".quantity__input")) || null;
    if (!input) return;
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      input.blur();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    var btn =
      e.target.closest(".gbfrequently-bought-with-main-whole button") ||
      e.target.closest(".gbfrequently-bought-with-main-whole .gb-sumbit-free") ||
      e.target.closest(".gb-free-product-trigger") ||
      e.target.closest(".gb-product-shipping-protection-product-tirgger") ||
      e.target.closest(".gb-product-sticky-add-to-cart-form");
    if (!btn) return;
    var parentBlock = btn.closest(".gb-get-main-freq-pro") || btn.closest("form");
    if (!parentBlock) {
      console.error("Could not find parent block for frequently bought product");
      return;
    }
    var productId = null;
    var idInput = parentBlock.querySelector('input[name="id"]');
    if (idInput && idInput.value) {
      productId = idInput.value;
    } else if (parentBlock.querySelector(".gb-change-variant_id")) {
      var select = parentBlock.querySelector(".gb-change-variant_id");
      var opt = select && select.options[select.selectedIndex];
      if (opt) {
        productId = opt.getAttribute("data-variant-id");
      }
    } else if (parentBlock.querySelector(".product-variant-id")) {
      var variantInput = parentBlock.querySelector(".product-variant-id");
      productId = variantInput ? variantInput.value : null;
    } else if (btn.getAttribute("data-variant-id")) {
      productId = btn.getAttribute("data-variant-id");
    }
    console.log("Frequently bought product add to cart - ID:", productId);
    if (btn.classList.contains("gb-free-product-trigger") && !show_progress_bar) return;
    if (!productId) {
      console.error("Missing product ID for frequently bought product");
      e.preventDefault();
      return false;
    }
    if (!idInput) {
      console.log("Adding missing ID input to frequently bought product form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = productId;
      parentBlock.appendChild(newIdInput);
    } else {
      idInput.value = productId;
    }
    var quantityInput = parentBlock.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      console.log("Adding default quantity input to frequently bought product form");
      var newQtyInput = document.createElement("input");
      newQtyInput.type = "hidden";
      newQtyInput.name = "quantity";
      newQtyInput.value = "1";
      parentBlock.appendChild(newQtyInput);
    } else if (!quantityInput.value || parseFloat(quantityInput.value, 10) < 1) {
      quantityInput.value = "1";
    }
  });
});

// Kaching showing Price(Compare Price) Text in ATC fix

const KachingApp = () => {
  const isProductPage = document.querySelector('.shopify-section.shop-product-section');
  if (!isProductPage) return;

  let buttonObserver = null;

  const createElement = (tag, cls, content) => {
    const el = document.createElement(tag);
    el.classList.add(...cls.split(' '));
    el.textContent = content;
    return el;
  };

  const updateAddToCartButton = (bundle) => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    if (!addToCartButton || !bundle) return;

    const buttonTextEl = addToCartButton.querySelector('.button-text');
    if (!buttonTextEl) return;

    const bundlePriceEl = bundle.querySelector('.kaching-bundles__bar-price');
    const bundleComparePriceEl = bundle.querySelector('.kaching-bundles__bar-full-price');

    if (bundlePriceEl) {
      const price = bundlePriceEl.textContent.trim();
      const comparePrice = bundleComparePriceEl ? bundleComparePriceEl.textContent.trim() : '';

      // Get the persistent text (e.g., "Buy Now")
      const persistentText = addToCartButton.getAttribute('data-persistent-text') || 'Buy Now';

      // Update button text with actual values
      if (comparePrice) {
        buttonTextEl.innerHTML = `${persistentText} - ${price}<span class="compare-price">(${comparePrice})</span>`;
      } else {
        buttonTextEl.innerHTML = `${persistentText} - ${price}`;
      }

      // Store current bundle reference for observer
      addToCartButton.dataset.currentBundlePrice = price;
      addToCartButton.dataset.currentBundleComparePrice = comparePrice || '';
    }
  };

  const forceUpdateButton = () => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    const buttonTextEl = addToCartButton?.querySelector('.button-text');
    
    if (!buttonTextEl) return;

    const price = addToCartButton.dataset.currentBundlePrice;
    const comparePrice = addToCartButton.dataset.currentBundleComparePrice;
    const persistentText = addToCartButton.getAttribute('data-persistent-text') || 'Buy Now';

    // Check if button shows placeholders
    if (buttonTextEl.textContent.includes('[price]') || buttonTextEl.textContent.includes('[comparePrice]')) {
      if (price) {
        if (comparePrice) {
          buttonTextEl.innerHTML = `${persistentText} - ${price}<span class="compare-price">(${comparePrice})</span>`;
        } else {
          buttonTextEl.innerHTML = `${persistentText} - ${price}`;
        }
      }
    }
  };

  const setupButtonObserver = () => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    if (!addToCartButton) return;

    // Disconnect existing observer if any
    if (buttonObserver) {
      buttonObserver.disconnect();
    }

    // Create new observer to watch for button text changes
    buttonObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          // Use setTimeout to let the other script finish, then override
          setTimeout(forceUpdateButton, 0);
        }
      });
    });

    // Observe the button and its children for any changes
    buttonObserver.observe(addToCartButton, {
      childList: true,
      subtree: true,
      characterData: true,
      characterDataOldValue: true
    });
  };

  const updatePriceBlock = (bundle) => {
    const priceBlock = document.querySelector('.shop-product-price-container');
    if (!priceBlock || !bundle) return;

    const priceEl = priceBlock.querySelector('.shop-product-price-block');
    const comparePriceEl = priceBlock.querySelector('.shop-compare-price');

    const bundlePriceEl = bundle.querySelector('.kaching-bundles__bar-price');
    const bundleComparePriceEl = bundle.querySelector('.kaching-bundles__bar-full-price');

    if (priceEl && bundlePriceEl) priceEl.textContent = bundlePriceEl.textContent;

    if (bundleComparePriceEl) {
      if (comparePriceEl) {
        comparePriceEl.textContent = bundleComparePriceEl.textContent;
      } else {
        priceBlock.appendChild(
          createElement('span', 'shop-compare-price', bundleComparePriceEl.textContent)
        );
      }
    }
  };

  const updateAllPrices = (bundle) => {
    updatePriceBlock(bundle);
    updateAddToCartButton(bundle);
    
    // Force update again after a short delay to override any competing scripts
    setTimeout(() => forceUpdateButton(), 50);
    setTimeout(() => forceUpdateButton(), 200);
  };

  const initApp = (app) => {
    const applyFirstCheckedBundle = () => {
      const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
      if (selectedBundle) {
        updateAllPrices(selectedBundle);
      }
    };

    const initAppFunctions = () => {
      const interval = setInterval(() => {
        const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
        if (selectedBundle) {
          clearInterval(interval);
          updateAllPrices(selectedBundle);
          setupButtonObserver();
        }
      }, 300);
    };

    app.addEventListener('change', () => {
      const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
      updateAllPrices(selectedBundle);
    });

    applyFirstCheckedBundle();
    initAppFunctions();
  };

  const interval = setInterval(() => {
    const app = document.querySelector('kaching-bundle');
    if (app) {
      clearInterval(interval);
      initApp(app);
    }
  }, 300);
};

window.addEventListener('DOMContentLoaded', KachingApp);
const ReBloomCartEnhancements = (() => {
  const optOutKey = 'rebloomShippingProtectionOptOut';
  let busy = false;
  let syncTimer = null;

  const root = () => window.Shopify?.routes?.root || '/';
  const protectionCards = () => [...document.querySelectorAll('[data-rb-shipping-protection]')];
  const getVariantId = () => protectionCards()[0]?.dataset.protectionVariantId || '';
  const autoAddEnabled = () => protectionCards().some((card) => card.dataset.autoAdd === 'true' && card.dataset.protectionAvailable === 'true');
  const hasOptedOut = () => {
    try {
      return sessionStorage.getItem(optOutKey) === '1';
    } catch (error) {
      return false;
    }
  };
  const setOptOut = (value) => {
    try {
      if (value) sessionStorage.setItem(optOutKey, '1');
      else sessionStorage.removeItem(optOutKey);
    } catch (error) {
      return;
    }
  };

  const setLoading = (isLoading) => {
    protectionCards().forEach((card) => {
      card.classList.toggle('is-loading', isLoading);
      const input = card.querySelector('[data-rb-protection-toggle]');
      if (input) input.disabled = isLoading;
    });
  };

  const getCart = async () => {
    const response = await fetch(`${root()}cart.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  };

  const sectionIds = () => {
    const ids = ['cart-drawer', 'cart-icon-bubble'];
    const mainItems = document.getElementById('main-cart-items');
    const mainFooter = document.getElementById('main-cart-footer');
    if (mainItems?.dataset.id) ids.push(mainItems.dataset.id);
    if (mainFooter?.dataset.id) ids.push(mainFooter.dataset.id);
    return [...new Set(ids.filter(Boolean))];
  };

  const getSectionInner = (html, selector) => {
    if (!html) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : null;
  };

  const renderSections = (state) => {
    if (!state?.sections) return;

    const drawerHtml = state.sections['cart-drawer'];
    if (drawerHtml) {
      const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
      const newDrawer = doc.querySelector('#CartDrawer');
      const currentDrawer = document.querySelector('cart-drawer');
      if (newDrawer && currentDrawer && typeof window.updateCartDrawer === 'function') {
        window.updateCartDrawer(currentDrawer, newDrawer, false);
      } else if (newDrawer) {
        const currentInner = document.querySelector('#CartDrawer');
        if (currentInner) currentInner.replaceWith(newDrawer);
      }
    }

    const bubbleHtml = state.sections['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && bubble) {
      const iconType = bubble.getAttribute('data-cart-icon-type');
      const inner = getSectionInner(bubbleHtml, '.shopify-section');
      if (inner !== null) bubble.innerHTML = inner;
      if (iconType) bubble.setAttribute('data-cart-icon-type', iconType);
    }

    const mainItems = document.getElementById('main-cart-items');
    if (mainItems?.dataset.id && state.sections[mainItems.dataset.id]) {
      const inner = getSectionInner(state.sections[mainItems.dataset.id], '.js-contents');
      const target = mainItems.querySelector('.js-contents');
      if (target && inner !== null) target.innerHTML = inner;
    }

    const footer = document.getElementById('main-cart-footer');
    if (footer?.dataset.id && state.sections[footer.dataset.id]) {
      const inner = getSectionInner(state.sections[footer.dataset.id], '.js-contents');
      const target = footer.querySelector('.js-contents');
      if (target && inner !== null) target.innerHTML = inner;
    }

    document.dispatchEvent(new CustomEvent('rebloom:cart-refreshed', { detail: { state } }));
  };

  const mutateProtection = async (variantId, quantity) => {
    if (!variantId || busy) return null;
    busy = true;
    setLoading(true);

    const sections = sectionIds();
    const url = quantity > 0
      ? (window.routes?.cart_add_url || `${root()}cart/add`)
      : (window.routes?.cart_change_url || `${root()}cart/change`);
    const body = quantity > 0
      ? { id: Number(variantId), quantity: 1, sections, sections_url: window.location.pathname }
      : { id: Number(variantId), quantity: 0, sections, sections_url: window.location.pathname };

    try {
      const response = await fetch(`${url}.js`.replace('.js.js', '.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify(body),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || 'Unable to update shipping protection');
      renderSections(state);
      return state;
    } catch (error) {
      console.error('ReBloom shipping protection:', error);
      return null;
    } finally {
      busy = false;
      setLoading(false);
    }
  };

  const syncProtection = async () => {
    if (busy || protectionCards().length === 0) return;
    const variantId = getVariantId();
    if (!variantId) return;

    try {
      const cart = await getCart();
      const protectionItem = cart.items.find((item) => String(item.variant_id) === String(variantId));
      const merchandiseQuantity = cart.items.reduce((total, item) => {
        return String(item.variant_id) === String(variantId) ? total : total + Number(item.quantity || 0);
      }, 0);
      const shouldHaveProtection = merchandiseQuantity > 0 && autoAddEnabled() && !hasOptedOut();

      protectionCards().forEach((card) => {
        card.dataset.protectionInCart = protectionItem ? 'true' : 'false';
        const input = card.querySelector('[data-rb-protection-toggle]');
        if (input && !busy) input.checked = Boolean(protectionItem || shouldHaveProtection);
      });

      if (shouldHaveProtection && !protectionItem) {
        await mutateProtection(variantId, 1);
      } else if ((!shouldHaveProtection || merchandiseQuantity === 0) && protectionItem && hasOptedOut()) {
        await mutateProtection(variantId, 0);
      } else if (merchandiseQuantity === 0 && protectionItem) {
        await mutateProtection(variantId, 0);
      }
    } catch (error) {
      console.error('ReBloom protection sync:', error);
    }
  };

  const queueSync = (delay = 80) => {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncProtection, delay);
  };

  const handleToggle = async (input) => {
    if (busy) return;
    const card = input.closest('[data-rb-shipping-protection]');
    const variantId = card?.dataset.protectionVariantId;
    if (!variantId) return;

    if (input.checked) {
      setOptOut(false);
      await mutateProtection(variantId, 1);
    } else {
      setOptOut(true);
      await mutateProtection(variantId, 0);
    }
  };

  const closeInfoPopovers = (exceptButton = null) => {
    document.querySelectorAll('.rb-shipping-protection__info[aria-expanded="true"]').forEach((button) => {
      if (button !== exceptButton) button.setAttribute('aria-expanded', 'false');
    });
  };

  const bindEvents = () => {
    document.addEventListener('change', (event) => {
      const toggle = event.target.closest?.('[data-rb-protection-toggle]');
      if (toggle) handleToggle(toggle);
    });

    document.addEventListener('click', (event) => {
      const infoButton = event.target.closest?.('.rb-shipping-protection__info');
      if (infoButton) {
        event.preventDefault();
        event.stopPropagation();
        const willOpen = infoButton.getAttribute('aria-expanded') !== 'true';
        closeInfoPopovers(infoButton);
        infoButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }
      closeInfoPopovers();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeInfoPopovers();
    });

    document.addEventListener('cart-drawer:render', () => queueSync(120));
    document.addEventListener('cart:ajax-update', () => queueSync(180));
    document.addEventListener('rebloom:cart-refreshed', () => queueSync(40));

    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => queueSync(160));
    }
  };

  const init = () => {
    bindEvents();
    queueSync(120);
  };

  return { init, syncProtection, queueSync };
})();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ReBloomCartEnhancements.init, { once: true });
} else {
  ReBloomCartEnhancements.init();
}
